import { PolygonFeatureLabel3D } from '../procedural/PolygonFeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from '../procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from '../procedural/SurfaceMeshFeature3D'
import { useSurfaceProps } from '@asset-viz/objects/surfaces/util/SurfaceProvider'
import React, { useMemo } from 'react'
import { GeckoComponentPolygon, GeckoShipDeckLocker } from 'types'

/**
 * component representing a locker on the surface of a ship deck component
 * @param model (the locker model from the asset model)
 * @constructor
 */
export const DeckLockerFeature3D: React.FC<{
  model: GeckoShipDeckLocker
}> = ({ model }) => {
  const { bounds, wrapMode } = useSurfaceProps()

  const boundingPath = useMemo(
    () =>
      GeckoComponentPolygon.CreateFromPolygonalPlate(
        model.polygonalPlate.geometry,
        bounds,
        wrapMode
      ),
    [bounds, model.polygonalPlate.geometry, wrapMode]
  )

  return (
    <group key={model.id}>
      <SurfaceLineFeature3D
        path={boundingPath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <SurfaceMeshFeature3D
        path={boundingPath}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        userDataName={'locker'}
      />
      <PolygonFeatureLabel3D feature={model} polygonPath={boundingPath} />
    </group>
  )
}
